


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import sleep from '../../../utils/sleep';

// https://github.com/PixelsCommander/Propeller
import 'Propeller';

@Component({
    components: {
    },
})
export default class CombinationLockVue extends Vue {

    // The code that solves the keypad
    @Prop({default: '10-5-15'})
    private code!: string;

    @Prop({default: 1})
    private tolerance!: number;

    private max = 30;
    private step = 5;
    private numbers: number[] = [];
    private current = 0;
    private propeller: any;
    private direction = +1;
    private current_code = [0];
    private enabled = true;
    private open = false;

    mounted(){

        let current = 0;
        do {
            this.numbers.push(current);
            current += this.step;
        } while(current < this.max)

        // @ts-ignore
        this.propeller = new window.Propeller(this.$refs.dial, {
            inertia: 0.5,
            //step: 360/this.max,
            onRotate: this.onRotate,
            //stepTransitionTime: 100,
        });

    }
    
    angle(){

        if(!this.propeller) return 0;

        let angle = (this.propeller.angle+360)*100;
        angle %= (360 * 100);
        angle /= 100;

        return angle;

    }

    onRotate(){

        this.current = Math.round(
            (360-this.angle()) * this.max / 360
        );

    }

    @Watch('current')
    onChange(){

        if(!this.enabled) return;

        const last:number = this.current_code.pop()!;

        if( ((this.current-last)*this.direction) > 0 ){
            this.current_code.push(this.current);
        } else {
            this.direction *= -1;
            this.current_code.push(last);
            this.current_code.push(this.current);
        }

        // Remove old numbers
        const code = this.code.split('-').map(x => +x);
        while(this.current_code.length > code.length){
            this.current_code.shift();
        }
        
        // Nothing to do
        if(this.current_code.length !== code.length) return;


        //
        // Check the code
        // 

        // Global ok
        let ok = true;
        // Current direction
        let dir = -1;

        // Iterate for each number in the code
        for(let i=0; i<code.length; i++){
            dir *= -1;

            // Check if we have found the code
            let found = false;
            // The tolerance allows to go further X numbers so it is easier to use
            for(let t=0; t<=this.tolerance; t++){
                if(code[i] === this.current_code[i]-t*dir){
                    found = true;
                }
            }

            // If not found any number or number+toleance, the code is wrong
            if(!found){
                ok = false;
                break;
            }
        }

        if(ok) this.show_success();

    } // onChange



    // Show sucess and emit
    async show_success(){

        this.open = true;

        await sleep(1000);

        this.enabled = false;

        await sleep(2000);

        this.$emit('success');

    }

    @Watch('enabled')
    onChangeEnabled(){

        if(!this.enabled){
            this.propeller.unbind();
        } else {
            this.propeller.bind();
        }

    }


    async reset(){

        if(!this.enabled) return;

        this.enabled = false;

        while(Math.abs(this.angle()) >= 2){

            const diff = this.current < (this.max/2) ?
                this.current :
                this.current - this.max;

            if(Math.abs(diff) < 2){
                break;
            }

            let speed = diff < 0 ? -10 : +10;
            this.propeller.speed = speed;
            await sleep(100);
        }

        this.propeller.angle = 0;
        this.propeller.stop();
        this.enabled = true;

    }



}

